"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAsisSessionStorage = exports.MbAsisSession = void 0;
const framework_1 = require("../../../framework");
const storage_1 = require("./storage");
Object.defineProperty(exports, "MbAsisSessionStorage", { enumerable: true, get: function () { return storage_1.MbAsisSessionStorage; } });
class MbAsisSession extends framework_1.BaseSession {
    constructor(sessionStorage, urlConfig) {
        super(sessionStorage);
        //TODO mismo refresh que MBSession, compartir el código
        this.doRefresh = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (!this.xhr) {
                throw Error('Set xhr before use Session');
            }
            try {
                const actualSessionInfo = {
                    refreshToken: (_a = this.getData()) === null || _a === void 0 ? void 0 : _a.refreshToken,
                    username: (_b = this.getData()) === null || _b === void 0 ? void 0 : _b.username,
                };
                //TODO: Logic to make recalls
                const { data: { accessToken, sessionExpiresAt, expiresIn, refreshToken }, } = yield this.xhr.POST(this.urlConfig.refreshToken, actualSessionInfo);
                //TODO: add DDD architecture to avoid endpoints and transformations here
                const newSessionData = {
                    accessToken,
                    sessionExpiresAt: sessionExpiresAt ? new Date(sessionExpiresAt) : null,
                    expiresIn,
                    refreshToken,
                    username: ((_c = this.getData()) === null || _c === void 0 ? void 0 : _c.username) || '',
                };
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                throw e;
            }
        });
        this.isDataValid = (sessionData) => {
            if (sessionData.accessToken && sessionData.refreshToken && sessionData.username) {
                return true;
            }
            return false;
        };
        this.xhr = null;
        this.urlConfig = urlConfig;
    }
    setXHR(newXhr) {
        this.xhr = newXhr;
    }
}
exports.MbAsisSession = MbAsisSession;
//# sourceMappingURL=index.js.map